module.exports = {"440902001":"红旗街道","440902002":"河西街道","440902003":"河东街道","440902004":"露天矿街道","440902005":"新华街道","440902006":"官渡街道","440902007":"站前街道","440902008":"城南街道","440902100":"金塘镇","440902101":"公馆镇","440902102":"新坡镇","440902103":"镇盛镇","440902104":"鳌头镇","440902105":"袂花镇","440902106":"高山镇","440902107":"山阁镇","440902108":"羊角镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440902.json
// module id = 2132
// module chunks = 0